import { render, staticRenderFns } from "./Shop.vue?vue&type=template&id=4d6868e8&"
import script from "./Shop.vue?vue&type=script&lang=js&"
export * from "./Shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../hoachipshop-ctv/client-ctv/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports